// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1OxE8","author":"Table_author__3Au2a","authorImage":"Table_authorImage__1mBKt","unreadRow":"Table_unreadRow__22lGD"};